import React from "react";
import { useHistory } from "react-router-dom";
import { Box, Button, Container, Typography, IconButton } from "@mui/material";
import { VideoCall, LightMode, DarkMode } from "@mui/icons-material";
import { useTheme } from "../../store/contexts/ThemeContext";
import { ROUTES } from "../../routes/User/paths";
import "./PublicHeader.css";

const PublicHeader = ({ scrolled = false }) => {
  const history = useHistory();
  const { darkMode, toggleTheme } = useTheme();

  return (
    <Box className={`public-navbar ${scrolled ? "scrolled" : ""}`}>
      <Container maxWidth="xl">
        <Box className="nav-content">
          <Box className="logo-section" onClick={() => history.push(ROUTES.landing)}>
            <Box className="logo-icon">
              <VideoCall sx={{ fontSize: 28 }} />
            </Box>
            <Typography variant="h6" className="logo-text">
              IOTA
            </Typography>
          </Box>

          {/* <Box className="nav-center">
            <Button
              className="nav-link"
              onClick={() => document.getElementById("features")?.scrollIntoView({ behavior: "smooth" })}
            >
              Features
            </Button>
            <Button
              className="nav-link"
              onClick={() => document.getElementById("pricing")?.scrollIntoView({ behavior: "smooth" })}
            >
              Pricing
            </Button>
            <Button className="nav-link" onClick={() => history.push(ROUTES.about)}>
              About
            </Button>
          </Box> */}

          <Box className="nav-actions">
            <IconButton onClick={toggleTheme} className="theme-toggle-btn" size="small">
              {darkMode ? <LightMode /> : <DarkMode />}
            </IconButton>
            <Button variant="text" className="nav-login" onClick={() => history.push(ROUTES.login)}>
              Log In
            </Button>
            <Button variant="contained" className="nav-signup" onClick={() => history.push(ROUTES.register)}>
              Sign Up
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default PublicHeader;
